(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-ui/assets/javascripts/message-list.js') >= 0) return;  svs.modules.push('/components/chat/chat-ui/assets/javascripts/message-list.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const chatUiMockable = svs.components.chat.chatUi;
const MoreMessagesButton = svs.components.chat.chatUi.MoreMessagesButton;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const _svs$components$chat$ = svs.components.chat.chatData.constants,
  MESSAGE_STATUS_SEND_PENDING = _svs$components$chat$.MESSAGE_STATUS_SEND_PENDING,
  MESSAGE_STATUS_SEND_FAILED = _svs$components$chat$.MESSAGE_STATUS_SEND_FAILED,
  MESSAGE_STATUS_SENT = _svs$components$chat$.MESSAGE_STATUS_SENT,
  MESSAGE_STATUS_DELETE_PENDING = _svs$components$chat$.MESSAGE_STATUS_DELETE_PENDING,
  MESSAGE_STATUS_DELETE_FAILED = _svs$components$chat$.MESSAGE_STATUS_DELETE_FAILED,
  MESSAGE_STATUS_DELETED = _svs$components$chat$.MESSAGE_STATUS_DELETED,
  MESSAGE_STATUS_NORMAL = _svs$components$chat$.MESSAGE_STATUS_NORMAL,
  MESSAGE_STATUS_EDITED = _svs$components$chat$.MESSAGE_STATUS_EDITED,
  MESSAGE_STATUS_INFO = _svs$components$chat$.MESSAGE_STATUS_INFO;
const SCROLL_OFFSET_NEW_MESSAGES = 10;
const ReactSwiper = React.forwardRef((props, ref) => React.createElement(svs.components.ReactSwiper, _extends({}, props, {
  forwardedRef: ref
})));

class MessageList extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      showNewMessageHint: false,
      lastAnnouncedMessage: '',
      liveRegionRef: React.createRef()
    });
    _defineProperty(this, "resolveMessageByStatus", (message, status) => {
      switch (status) {
        case MESSAGE_STATUS_DELETE_PENDING:
          return 'Meddelande tas bort...';
        case MESSAGE_STATUS_DELETED:
          return 'Meddelande borttaget';
        case MESSAGE_STATUS_INFO:
          return message.charAt(0).toUpperCase() + message.substr(1);
        default:
          return message;
      }
    });
    _defineProperty(this, "swiperRef", React.createRef());
    _defineProperty(this, "paginatorRef", React.createRef());
    _defineProperty(this, "lastMessageRef", React.createRef());
    _defineProperty(this, "intersectionObserver", null);
    _defineProperty(this, "timeoutId", null);
    _defineProperty(this, "handleIntersect", entries => {
      entries.forEach(entry => {
        if (entry.target === this.paginatorRef.current) {
          if (!this.props.loading && !this.props.hasLoadedEverything && entry.isIntersecting) {
            this.props.onFetchMessages({
              fetchRoom: this.props.isCurrentUserAuthenticated
            });
          }
        } else if (this.state.showNewMessageHint && entry.intersectionRatio > 0.4) {
          this.setState({
            showNewMessageHint: false
          });
        }
      });
    });
  }
  componentDidMount() {
    this.scrollToBottom();
    this.intersectionObserver = new IntersectionObserver(this.handleIntersect, {
      root: this.swiperRef.current,
      threshold: [0, 0.5]
    });
    this.timeoutId = setTimeout(() => this.intersectionObserver.observe(this.paginatorRef.current));
  }

  getSnapshotBeforeUpdate(prevProps) {
    const snapshot = {};
    const oldMsgList = prevProps.messageList;
    const newMsgList = this.props.messageList;
    if (oldMsgList === newMsgList) {
      return snapshot;
    }
    const oldLast = oldMsgList[oldMsgList.length - 1] || {};
    const newLast = newMsgList[newMsgList.length - 1] || {};
    if (oldMsgList.length === newMsgList.length && (oldLast.id === newLast.id || oldLast.localId === newLast.localId) && oldLast.status === newLast.status) {
      return snapshot;
    }
    const _this$swiperRef$curre = this.swiperRef.current,
      scrollHeight = _this$swiperRef$curre.scrollHeight,
      clientHeight = _this$swiperRef$curre.clientHeight,
      scrollTop = _this$swiperRef$curre.scrollTop;
    if (oldMsgList.length && newMsgList.length && oldMsgList[0].id !== newMsgList[0].id) {
      snapshot.didReceiveOldMessagesUpTop = true;
      snapshot.prevScrollBottom = scrollHeight - scrollTop;
    } else if (Object.keys(newLast).length > 0 && (oldLast.id !== newLast.id || oldLast.localId !== newLast.localId || oldLast.status !== newLast.status)) {
      snapshot.didReceiveNewMessagesDownBelow = true;
      const isCloseToBottom = scrollHeight - clientHeight - SCROLL_OFFSET_NEW_MESSAGES < scrollTop;
      snapshot.shouldScrollDown = isCloseToBottom || newLast.isMe;
      if (this.lastMessageRef.current) {
        this.intersectionObserver.unobserve(this.lastMessageRef.current);
      }
    }
    return snapshot;
  }
  componentDidUpdate(prevProps, prevState) {
    let snapshot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (snapshot.didReceiveNewMessagesDownBelow) {
      this.intersectionObserver.observe(this.lastMessageRef.current);
      if (snapshot.shouldScrollDown) {
        this.scrollToBottom();
      } else if (!this.state.showNewMessageHint) {
        this.setState({
          showNewMessageHint: true
        }); 
      }
      const lastMessage = this.props.messageList[this.props.messageList.length - 1];
      if (lastMessage) {
        const name = lastMessage.name,
          message = lastMessage.message,
          status = lastMessage.status,
          createdAt = lastMessage.createdAt;
        const messageText = this.resolveMessageByStatus(message, status);
        const formatedDate = [formatDate(createdAt, true, true, true)];
        const contentToAnnounce = "".concat(name, ": ").concat(messageText, ", ").concat(formatedDate);
        if (contentToAnnounce !== this.state.lastAnnouncedMessage) {
          this.setState({
            lastAnnouncedMessage: contentToAnnounce
          });
        }
      }
    } else if (snapshot.didReceiveOldMessagesUpTop) {
      this.swiperRef.current.scrollTop = this.swiperRef.current.scrollHeight - snapshot.prevScrollBottom;
    }
  }
  componentWillUnmount() {
    this.intersectionObserver.disconnect();
    clearTimeout(this.timeoutId);
  }
  scrollToBottom() {
    this.swiperRef.current.scrollTop = this.swiperRef.current.scrollHeight;
  }
  render() {
    const _this$props = this.props,
      messageList = _this$props.messageList,
      onDeleteMessage = _this$props.onDeleteMessage,
      onDeleteQueuedMessage = _this$props.onDeleteQueuedMessage,
      onResendMessage = _this$props.onResendMessage,
      error = _this$props.error,
      loading = _this$props.loading,
      hasLoadedEverything = _this$props.hasLoadedEverything,
      onFetchMessages = _this$props.onFetchMessages,
      onRetryReconnect = _this$props.onRetryReconnect,
      canEditUser = _this$props.canEditUser,
      onBlockUser = _this$props.onBlockUser;
    const list = messageList.map((_ref, n) => {
      let id = _ref.id,
        localId = _ref.localId,
        message = _ref.message,
        isMe = _ref.isMe,
        isRetailer = _ref.isRetailer,
        name = _ref.name,
        createdAt = _ref.createdAt,
        editedAt = _ref.editedAt,
        status = _ref.status,
        userStatus = _ref.userStatus,
        customerId = _ref.customerId;
      const deleter = id ? () => onDeleteMessage(id) : () => onDeleteQueuedMessage(localId);
      const handleBlockUser = () => onBlockUser(customerId);
      const resender = () => onResendMessage(localId);
      return React.createElement(chatUiMockable.Message, {
        canEditUser: canEditUser,
        createdAt: createdAt,
        editedAt: editedAt,
        isMe: isMe,
        isRetailer: isRetailer,
        key: id || localId || "robot_".concat(message),
        message: message,
        messageStatus: status,
        name: name,
        onBlockUser: handleBlockUser,
        onDeleteMessage: deleter,
        onResendMessage: resender,
        ref: n === messageList.length - 1 ? this.lastMessageRef : undefined,
        userStatus: userStatus,
        wrap: this.props.isCurrentUserAuthenticated
      });
    });
    return React.createElement(React.Fragment, null, React.createElement(ReactSwiper, {
      className: "chat-message-list-swiper",
      "data-testid": "chat-message-list",
      ref: this.swiperRef
    }, React.createElement("div", {
      className: "chat-message-list ".concat(!list.length ? ' chat-message-list--empty' : '')
    }, React.createElement("div", {
      className: "chat-message-list-inner qa-scroll-box",
      role: "list"
    }, React.createElement(chatUiMockable.ChatPageLoader, {
      empty: !list.length,
      error: error,
      hasLoadedEverything: hasLoadedEverything,
      loading: loading,
      onFetchMessages: onFetchMessages,
      onRetryReconnect: onRetryReconnect,
      ref: this.paginatorRef
    }), list, React.createElement("div", {
      "aria-atomic": "true",
      className: "sr-only",
      ref: this.state.liveRegionRef,
      role: "status"
    }, this.state.lastAnnouncedMessage)))), React.createElement(MoreMessagesButton
    , {
      onClick: () => this.scrollToBottom(),
      show: this.state.showNewMessageHint
    }));
  }
}
MessageList.defaultProps = {
  isCurrentUserAuthenticated: true,
  messageList: []
};
setGlobal('svs.components.chat.chatUi.MessageList', MessageList);

 })(window);